import { SessionTypes } from './modules/common/constants';

export const FOOD_ITEMS = {
  Breakfast: {
    Entrees: [
      {
        Id: 1,
        Description: 'Bread',
        selected: false,
        price: 1,
        category: 'Entrees',
      },
      {
        Id: 2,
        Description: 'Milk',
        selected: false,
        price: 2,
        category: 'Entrees',
      },
      {
        Id: 3,
        Description: 'Tea',
        selected: false,
        price: 3,
        category: 'Entrees',
      },
      {
        Id: 4,
        Description: 'Pasta',
        selected: false,
        price: 4,
        category: 'Entrees',
      },
      {
        Id: 5,
        Description: 'Pizza',
        selected: false,
        price: 5,
        category: 'Entrees',
      },
      {
        Id: 6,
        Description: 'Burger',
        selected: false,
        price: 6,
        category: 'Entrees',
      },
      {
        Id: 7,
        Description: 'French Fries',
        selected: false,
        price: 7,
        category: 'Entrees',
      },
      {
        Id: 8,
        Description: 'Poha',
        selected: false,
        price: 8,
        category: 'Entrees',
      },
      {
        Id: 9,
        Description: 'Vada Pav',
        selected: false,
        price: 9,
        category: 'Entrees',
      },
      {
        Id: 10,
        Description: 'Upma',
        selected: false,
        price: 1,
        category: 'Entrees',
      },
      {
        Id: 11,
        Description: 'Seed Toast',
        selected: false,
        price: 2,
        category: 'Entrees',
      },
      {
        Id: 12,
        Description: 'Oatmeal',
        selected: false,
        price: 33,
        category: 'Entrees',
      },
      {
        Id: 13,
        Description: 'Toast',
        selected: false,
        price: 43,
        category: 'Entrees',
      },
      {
        Id: 14,
        Description: 'sandwich',
        selected: false,
        price: 2,
        category: 'Entrees',
      },
      {
        Id: 15,
        Description: 'English muffins',
        selected: false,
        price: 3,
        category: 'Entrees',
      },
      {
        Id: 16,
        Description: 'Gogli',
        selected: false,
        price: 4,
        category: 'Entrees',
      },
      {
        Id: 17,
        Description: 'GrIddle scone',
        selected: false,
        price: 1,
        category: 'Entrees',
      },
      {
        Id: 18,
        Description: 'Home fries',
        selected: false,
        price: 2,
        category: 'Entrees',
      },
      {
        Id: 19,
        Description: 'Bacon',
        selected: false,
        price: 3,
        category: 'Entrees',
      },
      {
        Id: 20,
        Description: 'Bagel',
        selected: false,
        price: 4,
        category: 'Entrees',
      },
      {
        Id: 21,
        Description: 'Boiled egg',
        selected: false,
        price: 5,
        category: 'Entrees',
      },
      {
        Id: 22,
        Description: 'Banana',
        selected: false,
        price: 6,
        category: 'Entrees',
      },
      {
        Id: 23,
        Description: 'Calas',
        selected: false,
        price: 7,
        category: 'Entrees',
      },
      {
        Id: 24,
        Description: 'Croissant',
        selected: false,
        price: 8,
        category: 'Entrees',
      },
      {
        Id: 25,
        Description: 'Doubles',
        selected: false,
        price: 9,
        category: 'Entrees',
      },
    ],
  },
  Lunch: {
    Entrees: [
      {
        Id: 26,
        Description: 'Chicken Skewers',
        selected: false,
        price: 1,
        category: 'Entrees',
      },
      {
        Id: 27,
        Description: 'Black beans and rice',
        selected: false,
        price: 2,
        category: 'Entrees',
      },
      {
        Id: 28,
        Description: 'Egg and black bean',
        selected: false,
        price: 3,
        category: 'Entrees',
      },
      {
        Id: 29,
        Description: 'Grilled cheese',
        selected: false,
        price: 4,
        category: 'Entrees',
      },
      {
        Id: 30,
        Description: 'Spaghetti',
        selected: false,
        price: 5,
        category: 'Entrees',
      },
    ],
    Drinks: [
      {
        Id: 31,
        Description: 'Coffee',
        selected: false,
        price: 1,
        category: 'Drinks',
      },
      {
        Id: 32,
        Description: 'Edamame',
        selected: false,
        price: 2,
        category: 'Drinks',
      },
      {
        Id: 33,
        Description: 'Whole-grain cereal',
        selected: false,
        price: 3,
        category: 'Drinks',
      },
      {
        Id: 34,
        Description: 'Trail mix',
        selected: false,
        price: 4,
        category: 'Drinks',
      },
    ],
    'A la carte': [
      {
        Id: 35,
        Description: 'Poached Salmon',
        selected: false,
        price: 1,
        category: 'A la carte',
      },
      {
        Id: 36,
        Description: 'Shrimp',
        selected: false,
        price: 2,
        category: 'A la carte',
      },
      {
        Id: 37,
        Description: 'Crab Meat',
        selected: false,
        price: 12,
        category: 'A la carte',
      },
    ],
  },
  Supper: {
    Entrees: [
      {
        Id: 38,
        Description: 'Bread',
        selected: false,
        price: 11,
        category: 'Entrees',
      },
      {
        Id: 39,
        Description: 'Chicken Skewers',
        selected: false,
        price: 2,
        category: 'Entrees',
      },
      {
        Id: 40,
        Description: 'Mixed Greens',
        selected: false,
        price: 3,
        category: 'Entrees',
      },
      {
        Id: 41,
        Description: 'Avocado',
        selected: false,
        price: 4,
        category: 'Entrees',
      },
      {
        Id: 42,
        Description: 'Hard-Cooked Eggs',
        selected: false,
        price: 5,
        category: 'Entrees',
      },
    ],
    Drinks: [
      {
        Id: 43,
        Description: 'Coffee',
        selected: false,
        price: 1,
        category: 'Drinks',
      },
      {
        Id: 44,
        Description: 'Edamame',
        selected: false,
        price: 2,
        category: 'Drinks',
      },
      {
        Id: 45,
        Description: 'Trail mix',
        selected: false,
        price: 3,
        category: 'Drinks',
      },
      {
        Id: 46,
        Description: 'Tea',
        selected: false,
        price: 4,
        category: 'Drinks',
      },
    ],
    'A la carte': [
      {
        Id: 47,
        Description: 'Caesar Salad',
        selected: false,
        price: 1,
        category: 'A la carte',
      },
      {
        Id: 48,
        Description: 'Grilled Jalisco',
        selected: false,
        price: 2,
        category: 'A la carte',
      },
      {
        Id: 49,
        Description: 'Seafood Salad',
        selected: false,
        price: 3,
        category: 'A la carte',
      },
    ],
  },
  'Other Items': {
    Entrees: [
      {
        Id: 1,
        Description: 'Bread',
        selected: false,
        price: 1,
        category: 'Entrees',
      },
      {
        Id: 2,
        Description: 'Milk',
        selected: false,
        price: 2,
        category: 'Entrees',
      },
      {
        Id: 3,
        Description: 'Tea',
        selected: false,
        price: 3,
        category: 'Entrees',
      },
    ],
  },
};

export const STUDENT_PROFILES = [
  {
    Id: 1,
    name: 'Sue Smith',
    type: 'student',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/1.jpg',
    balance: '5.2',
    servingNumber: '12345',
    teacher: 'Miss Rose D',
    grade: '7',
    site: 'Stuart W Cramer High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in student',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId Student',
      },
    },
  },
  {
    Id: 2,
    name: 'Jhonson Rose',
    type: 'student',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/2.jpg',
    balance: '7.2',
    servingNumber: '23442',
    teacher: 'Mr Andrew',
    grade: '6',
    site: 'Washington High School',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in student',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: true,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: true,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId Student',
      },
    },
  },
  {
    Id: 3,
    name: 'Alen Parkar',
    type: 'student',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/3.jpg',
    balance: '12.3',
    servingNumber: '2345',
    teacher: 'Miss Rose D',
    grade: '1',
    site: 'Stuart W Cramer High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in student',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: true,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: true,
        message: 'InvalId Student',
      },
    },
  },
  {
    Id: 4,
    name: 'Alina Blosom',
    type: 'student',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/4.jpg',
    balance: '15.5',
    servingNumber: '9876',
    teacher: 'Miss Rose D',
    grade: '9',
    site: 'Arcade High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in student',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: true,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId Student',
      },
    },
  },
  {
    Id: 5,
    name: 'DavId Brown',
    type: 'student',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/5.jpg',
    balance: '2.0',
    servingNumber: '6578',
    teacher: 'Mr Andy',
    grade: '2',
    site: 'Arcade High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in student',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: true,
        message: 'InvalId Student',
      },
    },
  },
];

export const TEACHER_PROFILES = [
  {
    Id: 11,
    name: 'Alison Smith',
    type: 'teacher',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '5.2',
    servingNumber: '78458',
    site: 'Stuart W Cramer High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in teacher',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId Teacher',
      },
    },
  },
  {
    Id: 12,
    name: 'Caroline Herschel',
    type: 'teacher',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '7.2',
    servingNumber: '43544',
    site: 'Washington High School',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in teacher',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: true,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: true,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId teacher',
      },
    },
  },
  {
    Id: 13,
    name: 'Dorothy Hodgkin',
    type: 'teacher',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '12.3',
    servingNumber: '44534',
    site: 'Stuart W Cramer High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in teacher',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: true,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: true,
        message: 'InvalId teacher',
      },
    },
  },
  {
    Id: 14,
    name: 'Edmond Halley',
    type: 'teacher',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '15.5',
    servingNumber: '9876',
    site: 'Arcade High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in teacher',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: true,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId teacher',
      },
    },
  },
  {
    Id: 15,
    name: 'Adriana Uria',
    type: 'teacher',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '2.0',
    servingNumber: '54654',
    site: 'Arcade High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in teacher',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: true,
        message: 'InvalId teacher',
      },
    },
  },
];

export const STAFF_PROFILES = [
  {
    Id: 101,
    name: 'Edwin Hubble',
    type: 'staff',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '5.2',
    servingNumber: '78458',
    site: 'Stuart W Cramer High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in staff',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId staff',
      },
    },
  },
  {
    Id: 102,
    name: 'Enrico Fermi',
    type: 'staff',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '7.2',
    servingNumber: '45434',
    site: 'Washington High School',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in staff',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: true,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: true,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId staff',
      },
    },
  },
  {
    Id: 103,
    name: 'Erwin Schroedinger',
    type: 'staff',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '12.3',
    servingNumber: '44534',
    site: 'Stuart W Cramer High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in staff',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: true,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: true,
        message: 'InvalId staff',
      },
    },
  },
  {
    Id: 104,
    name: 'Flossie Wong',
    type: 'staff',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '15.5',
    servingNumber: '9876',
    site: 'Arcade High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in staff',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: true,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId staff',
      },
    },
  },
  {
    Id: 105,
    name: 'Geraldine Seydoux',
    type: 'staff',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '2.0',
    servingNumber: '54654',
    site: 'Arcade High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in staff',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: true,
        message: 'InvalId staff',
      },
    },
  },
];

export const PARENT_PROFILES = [
  {
    Id: 1001,
    name: 'IngrId Daubechies',
    type: 'parent',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '5.2',
    servingNumber: '78458',
    site: 'Stuart W Cramer High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in parent',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId parent',
      },
    },
  },
  {
    Id: 1002,
    name: 'Jacqueline K. Barton',
    type: 'parent',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '7.2',
    servingNumber: '45434',
    site: 'Washington High School',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in parent',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: true,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: true,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId parent',
      },
    },
  },
  {
    Id: 1003,
    name: 'Jane Goodall',
    type: 'parent',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '12.3',
    servingNumber: '44534',
    site: 'Stuart W Cramer High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in parent',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: true,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: true,
        message: 'InvalId parent',
      },
    },
  },
  {
    Id: 1004,
    name: 'Lene Vestergaard',
    type: 'parent',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '15.5',
    servingNumber: '9876',
    site: 'Arcade High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in parent',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: true,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: false,
        message: 'InvalId parent',
      },
    },
  },
  {
    Id: 1005,
    name: 'Lise Meitner',
    type: 'parent',
    profileURL:
      'http://temp-images-mealsplus.s3-website.ap-south-1.amazonaws.com/6.jpg',
    balance: '2.0',
    servingNumber: '54654',
    site: 'Arcade High',
    symbolIndicator: {
      manuallyKeyed: {
        disable: false,
        message: 'Manually keyed in parent',
      },
      queuedDirection: {
        disable: false,
        message: 'Queued in from LEFT',
      },
      allergensIndicator: {
        disable: false,
        message: 'Allergens Indicator',
      },
      specialMessage: {
        disable: false,
        message: 'Low salt diet',
      },
      invalidStudent: {
        disable: true,
        message: 'InvalId parent',
      },
    },
  },
];

export const GROUPS = [
  { Id: 1, name: 'Class X|Div A', type: 'group' },
  { Id: 2, name: 'Class X|Div B', type: 'group' },
  { Id: 3, name: 'Class X|Div C', type: 'group' },
  { Id: 4, name: 'Class IX|Div A', type: 'group' },
  { Id: 5, name: 'Class IX|Div B', type: 'group' },
  { Id: 6, name: 'Class IX|Div C', type: 'group' },
  { Id: 7, name: 'Class VIII|Div A', type: 'group' },
  { Id: 8, name: 'Class VIII|Div B', type: 'group' },
  { Id: 9, name: 'Class VIII|Div C', type: 'group' },
  { Id: 10, name: 'Class II|Div A', type: 'group' },
  { Id: 11, name: 'Class II|Div B', type: 'group' },
  { Id: 12, name: 'Class II|Div C', type: 'group' },
];

export const TEACHER_GROUPS = [
  { Id: 1, name: 'Cash Graves', type: 'teacher-group' },
  { Id: 2, name: 'Amir Oconnor', type: 'teacher-group' },
  { Id: 3, name: 'Brock Sanders', type: 'teacher-group' },
  { Id: 4, name: 'Travis Mayer', type: 'teacher-group' },
  { Id: 5, name: 'Crystal Bender', type: 'teacher-group' },
  { Id: 6, name: 'Lorelei Huff', type: 'teacher-group' },
];

//TODO move these to indivIdual components
export const OTHER_ITEMS = 'Other Items';

export const MENU_ITEMS = [
  { Id: 1, Description: 'Queue', selected: false },
  { Id: 2, Description: 'Group', selected: false },
  { Id: 3, Description: 'Teacher', selected: false },
];

export const SITE_LIST = [
  {
    Id: 1,
    Description: 'MIddleton Primary School',
    selected: false,
    isCepOn: false,
  },
  {
    Id: 2,
    Description: `St Joseph's Convent High School`,
    selected: false,
    isCepOn: true,
  },
  {
    Id: 3,
    Description: `St. Anne's High School`,
    selected: false,
    isCepOn: false,
  },
  { Id: 4, Description: `St. Xavier School`, selected: false, isCepOn: false },
];

export const SUB_MENU = {
  [SessionTypes.Queue]: [
    { Id: 1, Description: 'Auto Serve', selected: false },
    { Id: 2, Description: 'Quick Serve Items', selected: false },
  ],
  [SessionTypes.Group]: [
    { Id: 1, Description: 'Auto Serve', selected: false, disabled: true },
    { Id: 2, Description: 'Quick Serve Items', selected: false },
  ],
  [SessionTypes.Teacher]: [
    { Id: 1, Description: 'Auto Serve', selected: false, disabled: true },
    { Id: 2, Description: 'Quick Serve Items', selected: false },
  ],
  [SessionTypes.Other]: [
    { Id: 1, Description: 'Auto Serve', selected: false },
    { Id: 2, Description: 'Quick Serve Items', selected: false },
  ],
};

export const CEP_TYPES = [
  { Id: 1, Description: 'Meal Counter', selected: true },
  {
    Id: 2,
    Description: 'Student Specific',
    selected: false,
  },
];



// WEBPACK FOOTER //
// ./src/pages/pointofsale/mockData.js